const GrowthCloudStoreHeader = () => {
  return (
    <div
      style={{
        backgroundImage: `url(/img/growthcloud-store.jpeg)`,
      }}
      className="tw:flex tw:flex-col tw:justify-center tw:p-10 tw:md:p-20 tw:text-white tw:text-center tw:font-semibold tw:w-full tw:mt-1 tw:text-lg tw:md:text-2xl tw:bg-center tw:bg-cover tw:bg-no-repeat"
    >
      Fueling Business Growth: Your Store for Success
    </div>
  );
};

export default GrowthCloudStoreHeader;
